import { ref } from 'vue';

const state = ref(null); // { title, message, resolve }

export function useConfirmDialog() {
    return state;
}

export function useConfirm() {
    function confirm(message, { title = 'Are you sure?', confirmLabel = 'Confirm', destructive = false } = {}) {
        return new Promise((resolve) => {
            state.value = { title, message, confirmLabel, destructive, resolve };
        });
    }
    return { confirm };
}
